<template>
  <div>
    <global-confirm-box ref="confirmBox"></global-confirm-box>

    <page-header
      :title="$t('messages')"
      :subtitle="$t('manage_messages')"
      icon="mdi-message-text"
      icon-color="primary"
    />

    <div class="px-6 mt-2" v-if="hasPermission">
      <v-tabs v-model="tab" bg-color="primary">
        <v-tab value="one" v-show="isAdmin">{{ $t("messages") }}</v-tab>
        <v-tab value="two">FCM</v-tab>
      </v-tabs>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <div
              v-if="isAdmin"
              style="display: flex; flex-wrap: wrap; margin-bottom: 25px"
            >
              <div style="width: 35%">
                <text-area
                  v-model="poruka"
                  id=""
                  :label="$t('create_message')"
                  :placeholder="$t('your_message_placeholder')"
                ></text-area>
                <br />
                <primary-button @click="saveMessage">
                  {{ $t("save") }}
                </primary-button>
              </div>
              <div style="width: 65%; padding-left: 20px">
                <h5 class="mb-2">{{ $t("all_messages") }}</h5>
                <p
                  v-for="(poruka, index) in sve_poruke"
                  style="
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                  "
                >
                  <span>{{ index + 1 }}. {{ poruka.message }}</span>
                  <span style="display: flex; align-items: center; gap: 8px;">
                    <edit-button @click="editPoruka(poruka)"></edit-button>
                    <remove-button @click="deletePorukaConfirm(poruka)"></remove-button>
                  </span>
                </p>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <FCMNotifications></FCMNotifications>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </div>
    <div v-else>
      <h3>{{ $t("no_permission_send_messages") }}</h3>
    </div>
    <global-dialog-card :title="$t('edit_message')" v-model="dialog">
      <text-area
        class="mt-2"
        v-model="edit_poruka.message"
        cols="70"
        rows="5"
      ></text-area>
      <label for="" style="color: rgba(0, 0, 0, 0.87); padding-left: 0; margin-left: 0">
        {{ $t("versions") }}
      </label>
      <v-row no-gutters justify="space-between">
        <text-field :placeholder="$t('app_version_min')" />
        <text-field :placeholder="$t('app_version_max')" />
      </v-row>
      <template #actions>
        <v-btn text @click="dialog = false">{{ $t("cancel") }}</v-btn>
        <primary-button @click="editMessage">
          {{ $t("edit") }}
        </primary-button>
      </template>
    </global-dialog-card>
  </div>
</template>

<script>
import FCMNotifications from "./fcm.vue";
import PageHeader from "@/components/global/PageHeader.vue";
import conf from "@/config";
import postService from "@/services/post"; 
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  components: {
    FCMNotifications,
    PageHeader,
  },
  data() {
    return {
      conf: conf,
      dialog: false,
      poruka: "",
      sve_poruke: "",
      restorani: [],
      restoran: "",
      kompanije: [],
      kompanija: "",
      korisnici: [],
      korisnik: [],
      edit_poruka: "",
      tab: 1,
    };
  },

  mounted() {
    if (this.isAdmin) this.load();
  },

  methods: {
    load() {
      postService.getAllMessages().then(({ data }) => {
        this.sve_poruke = data["poruke"];
        this.restorani = data["restorani"];
      })
      .catch(() => {
        this.showErrorSnackbar(this.$t("error_loading_messages"));
      });
    },
    editPoruka(poruka) {
      this.dialog = true;
      this.edit_poruka = poruka;
    },
    saveMessage() {
      if (this.poruka != "") {
        postService
          .saveMessage(this.poruka)
          .then(({ data }) => {
            if (data) {
              this.sve_poruke.push(data.data);
              this.poruka = "";
              this.showSuccessSnackbar(this.$t("message_saved"));
            }
          })
          .catch(() => {
            this.showErrorSnackbar(this.$t("error_saving_message"));
          });
      }
    },
    editMessage() {
      postService
        .editMessage(this.edit_poruka)
        .then(({ data }) => {
          if (data) {
            this.sve_poruke.filter((item) => {
              if (item.id == data.id) {
                item = data;
              }
            });
            this.dialog = false;
            this.showSuccessSnackbar(this.$t("message_updated"));
          }
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_updating_message"));
        });
    },
    deletePorukaConfirm(poruka) {
      this.$refs.confirmBox
        .open(
          this.$t("delete_message"),
          this.$t("delete_message_confirmation"),
          { color: "error" }
        )
        .then(() => {
          this.deletePoruka(poruka);
        })
        .catch(() => {
          // User cancelled
        });
    },
    deletePoruka(poruka) {
      postService
        .deleteMessage(poruka)
        .then(({ data }) => {
          if (data) {
            this.sve_poruke.filter((item, index) => {
              if (item.id == poruka.id) {
                this.sve_poruke.splice(index, 1);
              }
            });
            this.showSuccessSnackbar(this.$t("message_deleted"));
          }
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_deleting_message"));
        });
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.user.type === "admin";
    },
    hasPermission() {
      let menu = this.$store.state.user.user.user_menu.menu1;
      menu = JSON.parse(menu);
      return (
        menu.find((m) => m.title === "notifications") ||
        this.$store.state.user.user.type === "admin"
      );
    },
  },
};
</script>

<style scoped>
label {
  display: inline-block;
  color: white;
  padding: 0.5rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}

@media (max-width: 767px) {
  .col-sm-4 {
    max-width: 33.333%;
  }
}
</style>
